/** * @file ErrorMessage */
<template>
  <p class="error_message" :class="{js_error_message: validation}">
    <slot />
  </p>
</template>

<script>
export default {
  props: {
    validation: {
      type: Boolean,
      default: true
    }
  }
}
</script>
